import {
  isPersonalizationVariableName,
  personalizationVariableToken
} from './multimedia_text_editor/personalization_variable'

function canInsertPersonalizationVariable(target, token, selectionStart, selectionEnd) {
  if (!target || target.disabled) return false

  const selectedLength = Math.max(0, selectionEnd - selectionStart)
  const lengthAfterInsert = target.value.length - selectedLength + token.length

  return lengthAfterInsert <= target.maxLength
}

function insertPersonalizationVariable(target, token, selectionStart, selectionEnd) {
  if (!canInsertPersonalizationVariable(target, token, selectionStart, selectionEnd)) return false

  target.setRangeText(token, selectionStart, selectionEnd, 'end')
  target.dispatchEvent(new Event('input', { bubbles: true }))
  target.focus()

  return true
}

up.compiler('.js-insert_personalization_variable', element => {
  const variableName = element.dataset.personalizationVariable
  const target = document.getElementById(element.dataset.personalizationVariableTarget)
  if (!target || !isPersonalizationVariableName(variableName)) return

  const token = personalizationVariableToken(variableName)
  const dropdown = element.closest('.js-dropdown_redesign')
  const dropdownToggle = dropdown?.querySelector('.js-dropdown_toggle_redesign')
  const dropdownInitiallyDisabled = dropdownToggle?.disabled
  let selectionStart = target.value.length
  let selectionEnd = selectionStart
  const sync = () => {
    element.disabled = !canInsertPersonalizationVariable(target, token, selectionStart, selectionEnd)

    if (dropdownToggle && !dropdownInitiallyDisabled) {
      // Variable tokens differ in length, so the menu stays usable as long as one of its items fits.
      const items = Array.from(dropdown.querySelectorAll('.js-insert_personalization_variable'))
      dropdownToggle.disabled = items.every(item => item.disabled)
    }
  }
  const rememberSelectionAndSync = () => {
    selectionStart = target.selectionStart ?? target.value.length
    selectionEnd = target.selectionEnd ?? selectionStart
    sync()
  }

  up.on(target, 'input change keyup paste select click focus', rememberSelectionAndSync)
  sync()

  if (dropdownToggle) {
    up.on(dropdownToggle, 'click', sync)
  }

  up.on(element, 'click', event => {
    if (!insertPersonalizationVariable(target, token, selectionStart, selectionEnd)) {
      event.preventDefault()
    }
  })
})
